<template>
  <div class="p-acts">
    <avl-player-action
      :is-shown="!!getMyself && amAllowedToExecute && !!getExecuted"
      :backdrop-disabled="true"
      :title="'Choose a player to execute!'"
      :button-success="{
        callback: () =>
          this.$store.dispatch('executePlayer', {
            gameId: this.$route.params.id,
            submit: true,
          }),
        label: 'Execute',
      }"
    ></avl-player-action>

    <avl-player-action
      :is-shown="!!getMyself && amAllowedToAct"
      :backdrop-disabled="true"
      :title="'Choose your action.'"
      :button-success="{
        callback: () =>
          this.$store.dispatch('questAction', {
            gameId: this.$route.params.id,
            action: 'SUCCESS',
          }),
        label: 'Success',
      }"
      :button-danger="{
        callback: () =>
          this.$store.dispatch('questAction', {
            gameId: this.$route.params.id,
            action: 'FAIL',
          }),
        disabled:
          getStartingOptions.failFromServantsDisallowedMode && getMyself.role.team === 'SERVANTS',
        label: 'Fail',
      }"
    ></avl-player-action>

    <avl-player-action
      :is-shown="!!getMyself && playersAreChooseable"
      :backdrop-disabled="true"
      :title="`Submit your team: ${getProposedTeam.length} / ${getActiveQuestPlayersNeeded}`"
      :button-success="{
        callback: () =>
          this.$store.dispatch('proposeTeam', {
            gameId: this.$route.params.id,
            submit: true,
          }),
        disabled: !getCorrectAmountOfPlayersIsChosen,
        label: 'Submit',
      }"
      :button-danger="{
        callback: () => this.$store.dispatch('clearProposedTeam', this.$route.params.id),
        label: 'Clear',
      }"
    ></avl-player-action>

    <avl-player-action
      :is-shown="!!getMyself && amAllowedToVote"
      :backdrop-disabled="true"
      :title="'What do you say?'"
      :button-success="{
        callback: () =>
          this.$store.dispatch('teamVote', {
            gameId: this.$route.params.id,
            vote: 'APPROVE',
          }),
        label: 'Approve',
      }"
      :button-danger="{
        callback: () =>
          this.$store.dispatch('teamVote', {
            gameId: this.$route.params.id,
            vote: 'REJECT',
          }),
        label: 'Reject',
      }"
    ></avl-player-action>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import playerAction from './player-action';

  export default {
    computed: {
      ...mapGetters([
        'getStartingOptions',
        'getMyself',
        'amAllowedToExecute',
        'getExecuted',
        'amAllowedToAct',
        'playersAreChooseable',
        'getCorrectAmountOfPlayersIsChosen',
        'amAllowedToVote',
        'getProposedTeam',
        'getActiveQuestPlayersNeeded',
      ]),
    },
    components: {
      'avl-player-action': playerAction,
    },
  };
</script>
